'use client'

import { useLayoutEffect, useSyncExternalStore } from 'react'

let loadingQuery: string | null = null
const listeners = new Set<() => void>()

function subscribe(listener: () => void) {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export function getSearchResultsLoadingQuery() {
    return loadingQuery
}

function setLoadingQuery(query: string | null) {
    if (loadingQuery === query) return
    loadingQuery = query
    listeners.forEach((listener) => listener())
}

export function useSearchResultsLoadingQuery() {
    return useSyncExternalStore(subscribe, getSearchResultsLoadingQuery, () => null)
}

/**
 * Reports that the results for `query` are still loading. Runs as a layout effect so the
 * report lands before Universal Search decides, in its own effect, whether to close.
 */
export function useReportSearchResultsLoading(query: string | undefined, isLoading: boolean) {
    useLayoutEffect(() => {
        if (!query || !isLoading) return
        setLoadingQuery(query)
        return () => setLoadingQuery(null)
    }, [query, isLoading])
}
